module.exports = __webpack_public_path__ + "img/jp-selles-byn.b5fdfde7.png";